import { useState } from "react";
import { Box, Tab, Tabs, Paper, useMediaQuery, useTheme } from "@mui/material";
import ProfileForm from "./ProfileForm";
import PasswordForm from "./PasswordForm";
import SettingsForm from "./SettingsForm";
import { useTranslation } from "react-i18next";

const ProfileTabs = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [value, setValue] = useState(0);
  const { t } = useTranslation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabLabels = [
    {
      short: t("Dashboard_profile.tabs.profileShort"),
      long: t("Dashboard_profile.tabs.profileLong"),
    },
    {
      short: t("Dashboard_profile.tabs.passwordShort"),
      long: t("Dashboard_profile.tabs.passwordLong"),
    },
    {
      short: t("Dashboard_profile.tabs.settingsShort"),
      long: t("Dashboard_profile.tabs.settingsLong"),
    },
  ];

  return (
    <Paper
      elevation={3}
      sx={{
        p: { xs: 2, sm: 3 },
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        variant={isMobile ? "scrollable" : "fullWidth"}
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          mb: 3,
          "& .MuiTab-root": {
            minWidth: { xs: "auto", sm: 0 },
            px: { xs: 1, sm: 2 },
            fontSize: { xs: "0.75rem", sm: "0.875rem" },
          },
        }}
      >
        {tabLabels.map((label, index) => (
          <Tab key={index} label={isMobile ? label.short : label.long} />
        ))}
      </Tabs>

      <Box sx={{ overflow: "auto" }}>
        {value === 0 && <ProfileForm />}
        {value === 1 && <PasswordForm />}
        {value === 2 && <SettingsForm />}
      </Box>
    </Paper>
  );
};

export default ProfileTabs;
